module.exports = __webpack_public_path__ + "img/staff-2012-donation.6dc4d5a7.jpg";